import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

import BrandLogo from "./BrandLogo";

const fallbackNavigation = [
  ["Biler", "cars"],
  ["Selg bilen", "sell"],
  ["Om oss", "about"],
  ["Kontakt", "contact"],
];

export default function SiteHeader({ carsUrl, items, showCars = true }) {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigation = (items?.length ? items : fallbackNavigation.map(([label]) => label))
    .slice(0, 4)
    .map((label, index) => [label, ["cars", "sell", "about", "contact"][index]])
    .filter(([label]) => label?.trim());

  useEffect(() => {
    const onScroll = () => setScrollProgress(Math.min(Math.max(window.scrollY / 180, 0), 1));
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (section) => {
    if (section === "cars" && !showCars && carsUrl) {
      window.open(carsUrl, "_blank", "noopener,noreferrer");
      setMenuOpen(false);
      return;
    }
    document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header className={`site-header ${scrollProgress > 0.18 ? "site-header--scrolled" : ""}`} data-testid="site-navigation">
      <button aria-label="Gå til toppen" className="logo-button" data-testid="navigation-logo-button" onClick={() => goTo("top")}>
        <span className="logo-transition" data-testid="navigation-logo-transition">
          <motion.span className="logo-transition__full" animate={{ opacity: 1 - scrollProgress, x: -10 * scrollProgress, scale: 1 - 0.08 * scrollProgress }} transition={{ duration: 0.18, ease: "easeOut" }}>
            <BrandLogo />
          </motion.span>
          <motion.span className="logo-transition__mark" animate={{ opacity: scrollProgress, scale: 0.9 + 0.1 * scrollProgress }} transition={{ duration: 0.18, ease: "easeOut" }}>
            <BrandLogo compact />
          </motion.span>
        </span>
      </button>
      <nav className="desktop-nav" aria-label="Hovednavigasjon" data-testid="desktop-navigation-links">
        {navigation.map(([label, id]) => (
          <button data-testid={`navigation-${id}-button`} key={id} onClick={() => goTo(id)}>{label}</button>
        ))}
      </nav>
      <button aria-label={menuOpen ? "Lukk meny" : "Åpne meny"} className="menu-button" data-testid="mobile-menu-button" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <X size={20} /> : <Menu size={20} />}
      </button>
      <AnimatePresence>
        {menuOpen && (
          <motion.nav className="mobile-nav" data-testid="mobile-navigation-links" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}>
            {navigation.map(([label, id]) => (
              <button data-testid={`mobile-navigation-${id}-button`} key={id} onClick={() => goTo(id)}>{label}</button>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}